<script lang="ts">
  import { getContext } from "svelte"
  import { cn } from "$lib/utils"
  import type { TabsContext } from "./types"

  export let value: string
  export let disabled = false
  let className = ""
  export { className as class }

  const { selectedValue, selectTab } = getContext<TabsContext>("tabs")

  $: selected = $selectedValue === value

  function handleClick() {
    if (!disabled) {
      selectTab(value)
    }
  }
</script>

<button
  type="button"
  role="tab"
  aria-selected={selected}
  aria-controls={`${value}-content`}
  {disabled}
  class={cn(
    "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
    selected
      ? "bg-background text-foreground shadow-sm"
      : "text-muted-foreground hover:text-foreground",
    className,
  )}
  on:click={handleClick}
  {...$$restProps}
>
  <slot />
</button>
